import ArticleCard from '@/components/base/ArticleCard';
import { getFeaturedArticles } from '@/mocks/articles';

export default function FeaturedSection() {
  const featured = getFeaturedArticles();

  return (
    <section id="featured" className="max-w-7xl mx-auto px-4 md:px-6 py-16">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            精选推荐
          </h2>
          <p className="text-foreground-600 mt-2 text-sm">编辑团队精心挑选的优质资源</p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {featured.map((article) => (
          <ArticleCard key={article.slug} article={article} />
        ))}
      </div>
    </section>
  );
}